export const UNIBOX_MAIN_TEST_ID = "unibox-main-test-id";
export const UNIBOX_MAIN_DISPLAY_NAME = "UniBoxMain";

export const UNIBOX_MAIN_SLOT_TEST_ID = "unibox-main-slot-test-id";
export const UNIBOX_MAIN_SLOT_DISPLAY_NAME = "UniBoxMain.Slot";

export const UNIBOX_MAIN_SLOT_BOTTOM_TEST_ID =
    "unibox-main-slot-bottom-test-id";
export const UNIBOX_MAIN_SLOT_BOTTOM_DISPLAY_NAME = "UniBoxMain.SlotBottom";

export const UNIBOX_MAIN_SLOT_BOTTOM_LEFT_TEST_ID =
    "unibox-main-slot-bottom-left-test-id";
export const UNIBOX_MAIN_SLOT_BOTTOM_LEFT_DISPLAY_NAME =
    "UniBoxMain.SlotBottomLeft";

export const UNIBOX_MAIN_SLOT_BOTTOM_RIGHT_TEST_ID =
    "unibox-main-slot-bottom-right-test-id";
export const UNIBOX_MAIN_SLOT_BOTTOM_RIGHT_DISPLAY_NAME =
    "UniBoxMain.SlotBottomRight";

export const UNIBOX_MAIN_SLOT_LEFT_TEST_ID = "unibox-main-slot-left-test-id";
export const UNIBOX_MAIN_SLOT_LEFT_DISPLAY_NAME = "UniBoxMain.SlotLeft";

export const UNIBOX_MAIN_SLOT_MIDDLE_TEST_ID =
    "unibox-main-slot-middle-test-id";
export const UNIBOX_MAIN_SLOT_MIDDLE_DISPLAY_NAME = "UniBoxMain.SlotMiddle";

export const UNIBOX_MAIN_SLOT_RIGHT_TEST_ID = "unibox-main-slot-right-test-id";
export const UNIBOX_MAIN_SLOT_RIGHT_DISPLAY_NAME = "UniBoxMain.SlotRight";

export const UNIBOX_MAIN_SLOT_TOP_TEST_ID = "unibox-main-slot-top-test-id";
export const UNIBOX_MAIN_SLOT_TOP_DISPLAY_NAME = "UniBoxMain.SlotTop";

export const UNIBOX_MAIN_SLOT_TOP_LEFT_TEST_ID =
    "unibox-main-slot-top-left-test-id";
export const UNIBOX_MAIN_SLOT_TOP_LEFT_DISPLAY_NAME = "UniBoxMain.SlotTopLeft";

export const UNIBOX_MAIN_SLOT_TOP_RIGHT_TEST_ID =
    "unibox-main-slot-top-right-test-id";
export const UNIBOX_MAIN_SLOT_TOP_RIGHT_DISPLAY_NAME =
    "UniBoxMain.SlotTopRight";
